import './style.scss';

function ScrollFiller() {
  return <div className='scroll-filler-sJx9' />;
}

export default ScrollFiller;
